import React from 'react'
import { useTranslation } from 'react-i18next'

export type MessageBoxType = 'error' | 'warning' | 'success'

interface MessageBoxProps {
  type?: MessageBoxType
  message?: string
}

const STYLES: Record<MessageBoxType, React.CSSProperties> = {
  error: {
    backgroundColor: '#FEF2F2',
    borderColor: '#FECACA',
    color: '#991B1B',
  },
  warning: {
    backgroundColor: '#FEFCE8',
    borderColor: '#FEF08A',
    color: '#854D0E',
  },
  success: {
    backgroundColor: '#F0FDF4',
    borderColor: '#BBF7D0',
    color: '#166534',
  },
}

const BASE_STYLE: React.CSSProperties = {
  padding: '1rem',
  borderRadius: '0.5rem',
  border: '1px solid',
  borderColor: 'transparent',
  marginTop: '1rem',
  textAlign: 'center',
  minHeight: '5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

function MessageBox({ type, message }: MessageBoxProps) {
  const { t } = useTranslation('toast')
  const isVisible = Boolean(type && message)

  const getLabel = (): string => {
    switch (type) {
      case 'error':
        return t('error_label', 'Error')
      case 'warning':
        return t('warning_label', 'Warning')
      case 'success':
        return t('success_label', 'Success')
      default:
        return ''
    }
  }

  const style: React.CSSProperties = {
    ...BASE_STYLE,
    ...(type ? STYLES[type] : {}),
    visibility: isVisible ? 'visible' : 'hidden',
  }

  return (
    <div style={style}>
      <p style={{ fontSize: '0.875rem', margin: 0 }}>
        <span style={{ fontWeight: 600 }}>
          {isVisible ? `${getLabel()}:` : '\u00A0'}
        </span>{' '}
        {message ?? '\u00A0'}
      </p>
    </div>
  )
}

export default MessageBox
